import React from "react";
import { HelpCircle, X } from "lucide-react";
import { cn } from "@/utils";

interface FieldGroupProps {
  label: string;
  children: React.ReactNode;
  hint?: string;
  className?: string;
  /** Callback для удаления поля (показывает кнопку X справа от поля) */
  onRemove?: () => void;
}

const FieldGroup: React.FC<FieldGroupProps> = ({ label, children, hint, className, onRemove }) => {
  return (
    <div className={className}>
      <div className="flex items-center gap-1.5 mb-2">
        <label className="text-fs-xs font-medium text-ink-3">{label}</label>
        {hint && (
          <div className="group relative">
            <HelpCircle className="h-3.5 w-3.5 text-ink-4 cursor-help" />
            <div className="invisible opacity-0 group-hover:visible group-hover:opacity-100 transition-opacity duration-150 absolute left-0 bottom-full mb-2 w-56 px-2.5 py-2 bg-zinc-900 text-white text-fs-2xs leading-snug rounded-md shadow-shell-md z-10 pointer-events-none">
              {hint}
            </div>
          </div>
        )}
      </div>
      <div className="flex items-start gap-2">
        <div className={cn("flex-1 grid gap-3", React.Children.count(children) > 1 ? "grid-cols-3" : "grid-cols-1")}>
          {children}
        </div>
        {onRemove && (
          <button
            type="button"
            onClick={onRemove}
            className={cn(
              "flex-shrink-0 p-2 rounded-lg transition-colors mt-0.5",
              "text-ink-4 hover:text-red-600 hover:bg-red-50",
              "dark:hover:text-red-400 dark:hover:bg-red-900/15",
            )}
            title="Удалить поле"
          >
            <X size={16} />
          </button>
        )}
      </div>
    </div>
  );
};

export default FieldGroup;
